import { render, staticRenderFns } from "./Aboutwe.vue?vue&type=template&id=747ccaea&"
import script from "./Aboutwe.vue?vue&type=script&lang=js&"
export * from "./Aboutwe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports